import { Component } from '@angular/core';
import { AppComponent } from './app.component';
import { DatosSesionService } from './servicios/datos-sesion.service';
import { element } from 'protractor';
//import { UnidadAdministrativa } from './modelado/unidad-administrativa';

import { AppMenuComponent } from './app.menu.component';
import { Inject, forwardRef } from '@angular/core';
import { Router } from '@angular/router';

import { DOCUMENT } from '@angular/platform-browser';
import { environment } from '../../environments/environment';
import { MenuService } from './servicios/menu.service';
import { UnidadAdministrativa } from './modelado/sar/unidad-administrativa';


@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
    , styles: ['.ancho { width: 150px; .anchoDialogo = width: 500px;  }'
    ]
})
export class AppTopbarComponent {


    public static URL_LOGOUT: string = environment.URL_LOGOUT;


    nombreCompleto: string;

    muestraMenusito = false;

    displayDialog: boolean = false;

    listaUnidadesAdministrativas: UnidadAdministrativa[] = [];
    unidadSeleccionada: UnidadAdministrativa = new UnidadAdministrativa();

    constructor(
        public app: AppComponent
        , private _datosSesionService: DatosSesionService
        , private router: Router
        , private _menuServicio: MenuService
        , @Inject(DOCUMENT) private document: any
        // ,@Inject(forwardRef(() => AppComponent)) public app:AppComponent
        //  , @Inject(forwardRef(() => AppMenuComponent))  private _appMenuComponent: AppMenuComponent

    ) {


        this.nombreCompleto = this._datosSesionService.getUsuario().nombre;
        this.listaUnidadesAdministrativas = this._datosSesionService.getUnidadesAdministrativasUusuairo();
        console.log(this._datosSesionService.getUnidadSeleccionada() + " UUUUUUUUUUUUUUUUUUUUUUU");

        if (this.listaUnidadesAdministrativas) {
            /**
             * Carga las primera unidad que es la GENERAL
             **/
            //this.unidadSeleccionada = this.listaUnidadesAdministrativas[0].idUnidad === 0 && this.listaUnidadesAdministrativas.length > 1 ? this.listaUnidadesAdministrativas[this._datosSesionService.getUnidadSeleccionada()] : this.listaUnidadesAdministrativas[0];
            //console.log(this.unidadSeleccionada);
            for (var t=0;t<this.listaUnidadesAdministrativas.length;t++){
                if (this.listaUnidadesAdministrativas[t].idUnidad==this._datosSesionService.getUnidadSeleccionada()){
                    this.unidadSeleccionada = this.listaUnidadesAdministrativas [t];
                    this.cargarMenusUsuarioRolUnidad(0);
                    this._datosSesionService.unidadSeleccionadaAplicativo = this.unidadSeleccionada;
                    t=this.listaUnidadesAdministrativas.length+2;
                    console.log("Ubica unidad selecconada aplicativo "+this._datosSesionService.unidadSeleccionadaAplicativo.nombre);
                }else{
                    console.log(this.listaUnidadesAdministrativas[t].idUnidad+ " compara 1");
                    console.log(this._datosSesionService.getUnidadSeleccionada()+ " compara 2");
                }

            }



        }

    }

    abrirCambiarRol() {
        this.displayDialog = true;
    }

    clickMenusito(event, item) {
     //   console.log('muestra menusito click ' + event);
        //this.app.onTopbarItemClick(event,item);

        if (this.muestraMenusito == false) {
            this.muestraMenusito = true;
        } else {
            this.muestraMenusito = false;
        }

        // if(this.app.activeTopbarItem === item ){
        //     return true;
        // }else {
        //     return false;
        // }

    }


    cambiaUnidad(unidad: UnidadAdministrativa) {

        this.unidadSeleccionada = unidad;
        this._datosSesionService.unidadSeleccionadaAplicativo = unidad;
        this.cargarMenusUsuarioRolUnidad(unidad.idUnidad);
        this.displayDialog = false;
        this.router.navigate(['/']);


    }


    /**
     * Permite cargar ene l menu
     * @param idUnidad
     */
    cargarMenusUsuarioRolUnidad(idUnidad: number) {
        console.log("Carga por rol------------------------------------------------------------");
        this._menuServicio.consultaMenusPorAplicativoPorUsuarioPorUnidad(this._datosSesionService.getAplicativo().idAplicativo, this._datosSesionService.getUsuario().idUsuario, idUnidad).then(
            (resp: any) => {
                // this.model = resp.items;
                this._datosSesionService.menuUsuario = resp.items;
                // this.model = this._datosSession.menuUsuario ;
                this.app.menuUsuario = this._datosSesionService.menuUsuario;
            }
        ).catch(error => console.error('ERROR en cargarMenusUsuarioRolUnidad  Detalle:...', error));

    }


    comparaElemento(elemento): boolean {



        // if(this.app.activeTopbarItem === elemento ){
        //     console.log('valida true');

        //     return true;
        // }else {
        //     console.log('valida false');
        //     return false;
        // }
        return false;
    }



    /**
     * Cuando da click en el boton cambiar unidad
     */
    clickCambiarUnidad() {


        if (this.unidadSeleccionada
             && this.unidadSeleccionada.idUnidad != this._datosSesionService.unidadSeleccionadaAplicativo.idUnidad
        ) {
            // this.datosSesion.setIdRol(this.idRolSeleccionado);
            // this.nombreRol = this.datosSesion.getNombreRol();
            // this.app.menu = this.datosSesion.getMenuSGA();


            // this.unidadSeleccionada = unidad;


            this._datosSesionService.unidadSeleccionadaAplicativo = this.unidadSeleccionada;
            this.cargarMenusUsuarioRolUnidad(this.unidadSeleccionada.idUnidad);
            this.displayDialog = false;
            this.router.navigate(['/']);
            console.log('Cambia de unidad ' + this._datosSesionService.unidadSeleccionadaAplicativo.nombre);
            this._datosSesionService.guardarUnidad(this.unidadSeleccionada.idUnidad);
            this.displayDialog = false;
            this.router.navigate(['/']);
        } else {
            this.displayDialog = false;
        }
    }

    cerrarSesion() {
        localStorage.clear();
        this._datosSesionService.limpiar();
        localStorage.setItem('url_redireccion',environment.APP_URL+'#'+environment.APP_ID);
        this.document.location.href = AppTopbarComponent.URL_LOGOUT;

    }

}
